import React, { useState, useEffect } from "react";
import { FaStar, FaCheckCircle, FaChartLine, FaClock, FaShieldAlt } from "react-icons/fa";
import "../styles/ServicesHeroSection.css";

// Import background images from assets
import heroBg1 from "../assets/n1.png";
import heroBg2 from "../assets/a2.png";
import heroBg3 from "../assets/n3.png";
import heroBg4 from "../assets/a4.png";
import heroBg5 from "../assets/n5.png";
import heroBg6 from "../assets/c1.png";
import heroBg7 from "../assets/c2.png";

const ServicesHeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // You can add more images here
  const heroSlides = [
    { image: heroBg1, title: "Professional Investigation", subtitle: "Uncover the truth with expertise" },
    { image: heroBg2, title: "Corporate Security", subtitle: "Protect your business interests" },
    { image: heroBg3, title: "24/7 Support", subtitle: "Always here for you" },
    { image: heroBg4, title: "Expert Detectives", subtitle: "Highly trained professionals" },
    { image: heroBg5, title: "Advanced Technology", subtitle: "Cutting-edge investigation tools" },
    { image: heroBg6, title: "100% Confidential", subtitle: "Your privacy is guaranteed" },
    { image: heroBg7, title: "Pan India Network", subtitle: "Services across all major cities" },
  ];

  const stats = [
    { number: "5000+", label: "Cases Solved", icon: <FaCheckCircle />, color: "#3b82f6" },
    { number: "98%", label: "Success Rate", icon: <FaChartLine />, color: "#06d881" },
    { number: "24/7", label: "Support Available", icon: <FaClock />, color: "#f59e0b" },
    { number: "50+", label: "Expert Detectives", icon: <FaShieldAlt />, color: "#ef4444" },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [heroSlides.length]);

  return (
    <section className="services-hero-section">
      {/* Background Images */}
      <div className="services-hero-background">
        {heroSlides.map((slide, index) => (
          <div
            key={index}
            className={`services-hero-bg-img ${index === currentSlide ? "active" : ""}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="services-hero-overlay"></div>
          </div>
        ))}
      </div>

      {/* Content */}
      <div className="services-hero-content-wrapper">
        <div className="services-hero-badge">
          <FaStar className="hero-star" />
          <span>Premium Investigation Services</span>
        </div>
        <h1 className="services-hero-title">
          Comprehensive <span className="title-gradient">Investigation</span> Solutions
        </h1>
        <p className="services-hero-subtitle">
          We offer a wide range of professional detective services tailored to meet your 
          specific needs with discretion, expertise, and advanced technology.
        </p>
        <div className="services-hero-stats">
          {stats.map((stat, index) => (
            <div key={index} className="services-hero-stat">
              <div className="services-hero-stat-icon" style={{ color: stat.color }}>{stat.icon}</div>
              <div>
                <div className="services-hero-stat-number">{stat.number}</div>
                <div className="services-hero-stat-label">{stat.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Dots Navigation */}
      <div className="services-hero-dots">
        {heroSlides.map((_, index) => (
          <button
            key={index}
            className={`services-hero-dot ${index === currentSlide ? "active" : ""}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </section>
  );
};

export default ServicesHeroSection;